import type { FeePoolItem, RateOption } from './types';
import { suggestSell } from './logic';

// Soạn báo giá (Mint-QuoteEdit): phép tính thuần. Không có giá mua / margin ở đây — chỉ sau quyền `money`.

export const NF = (n: number): string => Math.round(n).toLocaleString('de-DE');
export const parseNum = (s: string): number => {
  const d = s.replace(/[^\d]/g, '');
  return d ? parseInt(d, 10) : 0;
};

export const CONT_TYPES = ['20DC', '40DC', '40HC', '40RF'] as const;
export type ContType = (typeof CONT_TYPES)[number];
export type ContCount = Record<ContType, number>;

export const totalCont = (c: ContCount): number => CONT_TYPES.reduce((s, k) => s + c[k], 0) || 1;
export const qtyLabel = (c: ContCount): string => CONT_TYPES.filter((k) => c[k] > 0).map((k) => `${c[k]}×${k}`).join(' + ') || '0 cont';

/** Giá bán gợi ý của phương án = giá mua + margin gợi ý (khách → tuyến chuẩn). Giá mua không ra khỏi hàm. */
export const suggestedSell = (r: Pick<RateOption, 'buy'>, marginPct: number): number => suggestSell(r.buy, marginPct);

export interface FeeLineCalc {
  vnd: number;
  vat: number;
  qty: number;
  base: number;
}

/** Một dòng local charge: đơn giá (đổi tiền theo tỷ giá nếu người soạn đổi USD ↔ VND) × SL, VAT theo mã phí. */
export function feeLine(f: FeePoolItem, cur: 'USD' | 'VND', override: number | undefined, fx: number, conts: number): FeeLineCalc {
  const base = override ?? (cur === f.cur ? f.price : cur === 'VND' ? f.price * fx : Math.round(f.price / fx));
  const qty = f.unit === 'cont' || f.unit === 'chuyến' ? conts : 1;
  const vnd = (cur === 'USD' ? base * fx : base) * qty;
  return { base, qty, vnd, vat: (vnd * f.vat) / 100 };
}

/** Hiệu lực = min(lựa chọn, hiệu lực giá hãng). */
export const validDays = (pick: '7' | '14' | '31', rateDays: number): number => Math.min(pick === '7' ? 7 : pick === '14' ? 14 : 31, rateDays);

const MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const dateOff = (n: number): string => {
  const x = new Date(Date.UTC(2026, 9, 22 + n));
  return `${String(x.getUTCDate()).padStart(2, '0')}/${MON[x.getUTCMonth()]}/${x.getUTCFullYear()}`;
};

/** Ref theo TblQuotation: Q + năm + F + R/D (reefer / dry) + POL3 + POD3 + số. */
export const refOf = (reefer: boolean, pol: string, pod: string, seq: number): string => `Q26F${reefer ? 'R' : 'D'}${pol === 'CLI' ? 'SGN' : pol}${pod}${String(seq).padStart(3, '0')}`;
